/**
 * API configuration
 * This file contains the configuration for the API
 */
import axios from 'axios';

// Environment-based configuration
const ENV = process.env.REACT_APP_ENV || 'development';
const IS_DEVELOPMENT = ENV === 'development';

// Configuration options
export const API_CONFIG = {
  timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000'),
  enableDirectApi: process.env.REACT_APP_ENABLE_DIRECT_API === 'true',
  debugApi: process.env.REACT_APP_DEBUG_API === 'true',
  environment: ENV,
  isDevelopment: IS_DEVELOPMENT
};

// Server URLs from environment variables
export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

// Indexer health port for direct health checks
export const INDEXER_HEALTH_PORT = process.env.REACT_APP_INDEXER_HEALTH_PORT || '3003';
export const INDEXER_HEALTH_URL = `http://localhost:${INDEXER_HEALTH_PORT}`;

// API base URL - use environment variable or construct from server URL
export const API_BASE = process.env.REACT_APP_API_URL?.startsWith('http')
  ? process.env.REACT_APP_API_URL
  : `${SERVER_URL}${process.env.REACT_APP_API_URL || '/api/bit/v1'}`;

// Auth API base URL for authentication operations (using proxy for cookies in development)
export const AUTH_API_BASE = IS_DEVELOPMENT
  ? (process.env.REACT_APP_API_URL || '/api/bit/v1')
  : API_BASE;

// Create a custom axios instance for API calls
export const apiClient = axios.create({
  baseURL: API_BASE,
  timeout: API_CONFIG.timeout,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true
});

// Log configuration in development
if (API_CONFIG.debugApi) {
  console.log('API Configuration:', {
    ENV,
    SERVER_URL,
    API_BASE,
    AUTH_API_BASE,
    ...API_CONFIG
  });
}

// Add request interceptor to include token from localStorage if available
apiClient.interceptors.request.use(function (config) {
  const token = localStorage.getItem('dashboard_token');
  if (token && config.headers) {
    // Add token to Authorization header
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Create a custom axios instance for auth calls
export const authClient = axios.create({
  baseURL: AUTH_API_BASE,
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  },
  withCredentials: true
});

// Add request interceptor to include token from localStorage if available
authClient.interceptors.request.use(function (config) {
  const token = localStorage.getItem('dashboard_token');
  if (token && config.headers) {
    // Add token to Authorization header
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

// Log API configuration
console.log('API_BASE:', API_BASE);
console.log('AUTH_API_BASE:', AUTH_API_BASE);
